<template>
	<sweet-modal
		:class="changeModalClass(setdialog.modalIcon)"
		class="modalEventTalkClass"
		:icon="setdialog.modalIcon"
		ref="modalEventTalk"
		:title="setdialog.title"
		hide-close-button
		blocking
	>
		<div class="preview_text" style="text-align:center; padding:0px">
			{{ setdialog.content }}
		</div>

		<v-btn
			class="preview_btn mt-7"
			color="#204037"
			dark
			depressed
			@click="$route.name === 'reserve_event' ? clickdoneBtn() : (setdialog.dialog = false)"
		>
			확인</v-btn
		>
	</sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
export default {
	components: { SweetModal },
	props: {
		setdialog: Object,
	},
	watch: {
		setdialog: {
			deep: true,
			handler() {
				if (this.setdialog.dialog) {
					this.$refs.modalEventTalk.open()
				} else {
					if (this.setdialog.endLink) {
						window.open(this.setdialog.endLink, '_self')
					}
					this.$store.state.closeActive += 1
					this.$refs.modalEventTalk.close()
				}
			},
		},
	},
	methods: {
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		clickdoneBtn() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		changeModalClass(val) {
			if (val === 'success') return 'success_modal'
			else if (val === 'info') return 'info_modal'
			else if (val === 'warning') return 'warning_modal'
			else if (val === 'error') return 'error_modal'
		},
	},
}
</script>

<style lang="scss">
.preview_btn {
	font-size: 13px !important;
	font-weight: bold !important;
	width: 164px !important;
	height: 26px !important;
	display: block;
	margin-left: auto;
	margin-right: auto;
}
.modalEventTalkClass {
	.sweet-modal {
		.sweet-content {
			padding: 0;
		}
		.sweet-title {
			h2 {
				font-weight: bold;
				font-size: 20px;
			}
			text-align: center;
			padding: 0;
			margin-top: 24px;
			border-bottom: none;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
			height: 64px;
			line-height: 64px;
		}
		max-width: 405px !important;
		padding: 0 16px 16px 16px !important;
		height: auto !important;
		.sweet-content {
			white-space: pre-line !important;
		}
	}
}
.create_wrap {
	background: #fff;
}
.project_title {
	background: #323153;
	color: #fff;
	height: 60px;
	display: flex;
	align-items: center;
}
.title_font {
	font-size: 15px;
	font-weight: bold;
}
.sub_text {
	border-left: 1px solid #d1d1d1;
}
.upload_box {
	margin: 0 auto !important;
}
.v-text-field__slot input {
	font-size: 12px;
	font-weight: normal;
}
.radioTime {
	.v-label {
		font-size: 0.75rem !important;
	}
}
</style>
